/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TournamentBracketGroup } from './TournamentBracketGroup';
import {
    TournamentBracketGroupFromJSON,
    TournamentBracketGroupFromJSONTyped,
    TournamentBracketGroupToJSON,
    TournamentBracketGroupToJSONTyped,
} from './TournamentBracketGroup';
import type { TournamentRoundRobinStanding } from './TournamentRoundRobinStanding';
import {
    TournamentRoundRobinStandingFromJSON,
    TournamentRoundRobinStandingFromJSONTyped,
    TournamentRoundRobinStandingToJSON,
    TournamentRoundRobinStandingToJSONTyped,
} from './TournamentRoundRobinStanding';
import type { TournamentSwissStanding } from './TournamentSwissStanding';
import {
    TournamentSwissStandingFromJSON,
    TournamentSwissStandingFromJSONTyped,
    TournamentSwissStandingToJSON,
    TournamentSwissStandingToJSONTyped,
} from './TournamentSwissStanding';
import type { BracketType } from './BracketType';
import {
    BracketTypeFromJSON,
    BracketTypeFromJSONTyped,
    BracketTypeToJSON,
    BracketTypeToJSONTyped,
} from './BracketType';
import type { BracketRound } from './BracketRound';
import {
    BracketRoundFromJSON,
    BracketRoundFromJSONTyped,
    BracketRoundToJSON,
    BracketRoundToJSONTyped,
} from './BracketRound';

/**
 * 
 * @export
 * @interface TournamentBracket
 */
export interface TournamentBracket {
    /**
     * 
     * @type {BracketType}
     * @memberof TournamentBracket
     */
    type?: BracketType;
    /**
     * 
     * @type {Array<BracketRound>}
     * @memberof TournamentBracket
     */
    rounds?: Array<BracketRound>;
    /**
     * For double elimination tournaments
     * @type {Array<BracketRound>}
     * @memberof TournamentBracket
     */
    losersRounds?: Array<BracketRound>;
    /**
     * Derived standings for round robin tournaments
     * @type {Array<TournamentRoundRobinStanding>}
     * @memberof TournamentBracket
     */
    roundRobinStandings?: Array<TournamentRoundRobinStanding>;
    /**
     * Derived standings for swiss tournaments
     * @type {Array<TournamentSwissStanding>}
     * @memberof TournamentBracket
     */
    swissStandings?: Array<TournamentSwissStanding>;
    /**
     * Group-stage pools for GROUPS_KNOCKOUT brackets; the knockout stage uses `rounds`
     * @type {Array<TournamentBracketGroup>}
     * @memberof TournamentBracket
     */
    groups?: Array<TournamentBracketGroup>;
}



/**
 * Check if a given object implements the TournamentBracket interface.
 */
export function instanceOfTournamentBracket(value: object): value is TournamentBracket {
    return true;
}

export function TournamentBracketFromJSON(json: any): TournamentBracket {
    return TournamentBracketFromJSONTyped(json, false);
}

export function TournamentBracketFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentBracket {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : BracketTypeFromJSON(json['type']),
        'rounds': json['rounds'] == null ? undefined : ((json['rounds'] as Array<any>).map(BracketRoundFromJSON)),
        'losersRounds': json['losersRounds'] == null ? undefined : ((json['losersRounds'] as Array<any>).map(BracketRoundFromJSON)),
        'roundRobinStandings': json['roundRobinStandings'] == null ? undefined : ((json['roundRobinStandings'] as Array<any>).map(TournamentRoundRobinStandingFromJSON)),
        'swissStandings': json['swissStandings'] == null ? undefined : ((json['swissStandings'] as Array<any>).map(TournamentSwissStandingFromJSON)),
        'groups': json['groups'] == null ? undefined : ((json['groups'] as Array<any>).map(TournamentBracketGroupFromJSON)),
    };
}

export function TournamentBracketToJSON(json: any): TournamentBracket {
    return TournamentBracketToJSONTyped(json, false);
}

export function TournamentBracketToJSONTyped(value?: TournamentBracket | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': BracketTypeToJSON(value['type']),
        'rounds': value['rounds'] == null ? undefined : ((value['rounds'] as Array<any>).map(BracketRoundToJSON)),
        'losersRounds': value['losersRounds'] == null ? undefined : ((value['losersRounds'] as Array<any>).map(BracketRoundToJSON)),
        'roundRobinStandings': value['roundRobinStandings'] == null ? undefined : ((value['roundRobinStandings'] as Array<any>).map(TournamentRoundRobinStandingToJSON)),
        'swissStandings': value['swissStandings'] == null ? undefined : ((value['swissStandings'] as Array<any>).map(TournamentSwissStandingToJSON)),
        'groups': value['groups'] == null ? undefined : ((value['groups'] as Array<any>).map(TournamentBracketGroupToJSON)),
    };
}

